import { render, staticRenderFns } from "./loading-company-info.vue?vue&type=template&id=34a88a71&scoped=true&"
import script from "./loading-company-info.vue?vue&type=script&lang=js&"
export * from "./loading-company-info.vue?vue&type=script&lang=js&"
import style0 from "./loading-company-info.vue?vue&type=style&index=0&id=34a88a71&lang=scss&scoped=true&"
import style1 from "./loading-company-info.vue?vue&type=style&index=1&id=34a88a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a88a71",
  null
  
)

export default component.exports
import {QCard,QItemSection,QAvatar,QSkeleton,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QItemSection,QAvatar,QSkeleton,QItemLabel,QIcon})
